import React, { useState, useEffect } from "react";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { config } from "../../config/config";
import ApprovalModal from "./ApprovalModal";
import Loader from "../Loader/Loader";
import DynamicDialog from "../Dialog/Dialog";
import Button from "@mui/material/Button";
import Tablestyles from "../../screens/Mapping/ROCITable.module.css";

let api = config.api.api_url;

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "50px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

const Row = ({
  keys,
  rowData,
  headingRow,
  isLoading,
  handleModalOpen,
  handleDynamicModal,
  usecase_name,
}) => {
  let data = rowData;

  const metadata = [
    { label: "file_id", name: "File_Id" },
    { label: "dataset_name", name: "SOURCE" },
    { label: "country_name", name: "COUNTRY_CODE" },
  ];

  const ApproveSourceFileId = () => {
    if (usecase_name === "gold_template_mapping") {
      handleDynamicModal(
        rowData.gold_layer,
        rowData.HARBOR_SOURCE_FILE_ID,
        rowData.COUNTRY,
        "Approve",
        metadata,
        rowData,
        rowData.TARGET_GOLD_LAYER,
      );
      return;
    }

    if (usecase_name === "pillar_and_power_brand_mapping") {
      handleDynamicModal(
        rowData.BUSINESS_UNIT,
        "NA",
        rowData.COUNTRY_CODE,
        "Approve",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }

    if (usecase_name === "market_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.File_Id,
        rowData.COUNTRY_CODE,
        "Approve",
        metadata,
        rowData,
        "NA",
      );
      return;
    }

    if (usecase_name === "product_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "Approve",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }

    if (usecase_name === "attribute_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "Approve",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }

    handleDynamicModal(
      rowData.dataset,
      rowData.File_Id,
      rowData.COUNTRY,
      "Approve",
      metadata,
      rowData,
      "NA",
    );
  };

  const handleReject = () => {
    if (usecase_name === "gold_template_mapping") {
      handleDynamicModal(
        rowData.gold_layer,
        rowData.HARBOR_SOURCE_FILE_ID,
        rowData.COUNTRY,
        "Reject",
        metadata,
        rowData,
        rowData.TARGET_GOLD_LAYER,
      );
      return;
    }

    if (usecase_name === "pillar_and_power_brand_mapping") {
      handleDynamicModal(
        rowData.BUSINESS_UNIT,
        "NA",
        rowData.COUNTRY_CODE,
        "Reject",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }
    if (usecase_name === "market_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.File_Id,
        rowData.COUNTRY_CODE,
        "Reject",
        metadata,
        rowData,
        "NA",
      );
      return;
    }
    if (usecase_name === "product_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "Reject",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }

    if (usecase_name === "attribute_mapping") {
      handleDynamicModal(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "Reject",
        metadata,
        rowData,
        rowData.SOURCE,
      );
      return;
    }

    handleDynamicModal(
      rowData.dataset,
      rowData.File_Id,
      rowData.COUNTRY,
      "Reject",
      metadata,
      rowData,
      "NA",
    );
  };

  const handleForward = () => {
    console.log("Forward Clicked");
  };

  const handleOpenModal = () => {
    if (usecase_name === "gold_template_mapping") {
      handleModalOpen(
        rowData.gold_layer,
        rowData.HARBOR_SOURCE_FILE_ID,
        rowData.COUNTRY,
        rowData.TARGET_GOLD_LAYER,
      );
      return;
    }

    if (usecase_name === "pillar_and_power_brand_mapping") {
      handleModalOpen(
        rowData.BUSINESS_UNIT,
        rowData.SOURCE,
        rowData.COUNTRY_CODE,
        "NA",
      );
      return;
    }
    if (usecase_name === "market_mapping") {
      handleModalOpen(
        rowData.SOURCE,
        rowData.File_Id,
        rowData.COUNTRY_CODE,
        "NA",
      );
      return;
    }

    if (usecase_name === "product_mapping") {
      handleModalOpen(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "NA",
      );
      return;
    }

    if (usecase_name === "attribute_mapping") {
      handleModalOpen(
        rowData.SOURCE,
        rowData.MAPPING_TYPE,
        rowData.COUNTRY_CODE,
        "NA",
      );
      return;
    }

    handleModalOpen(rowData.dataset, rowData.File_Id, rowData.COUNTRY, "NA");
  };

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      className={"table-row"}
      style={{ cursor: "pointer" }}
    >
      {headingRow.map(({ label, name }, index) => (
        <>
          {index !== headingRow.length - 1 && (
            <StyledTableCell
              key={`key-${index}`}
              className={""}
              onClick={handleOpenModal}
              style={{
                position: "relative",
                height: "45px",
                padding: "2px 3px",
                whiteSpace: "nowrap",
                textWrap: "wrap",
                cursor: "pointer",
              }}
            >
              {data[name] && typeof data[name] === "object"
                ? JSON.stringify(data[name])
                : data[name] || "None"}
            </StyledTableCell>
          )}
        </>
      ))}

      {/* Action Buttons */}
      <StyledTableCell
        className={""}
        style={{
          position: "relative",
          height: "50px",
          padding: "3px 3px",
          overflowX: "visible",
          whiteSpace: "nowrap",
          textWrap: "wrap",
          cursor: "pointer",
        }}
      >
        <div className="action-icon-container">
          <span>
            <i
              className="material-icons-outlined "
              disabled={isLoading}
              style={{
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
              onClick={ApproveSourceFileId}
            >
              done
            </i>
          </span>
          <span>
            <i
              className="material-icons-outlined "
              disabled={isLoading}
              style={{
                color: "red",
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
              onClick={handleReject}
            >
              cancel
            </i>
          </span>
          {/* <span>
            <i
              className="material-icons-outlined "
              disabled={isLoading}
              style={{
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
              onClick={handleForward}
            >
              forward
            </i>
          </span> */}
        </div>
      </StyledTableCell>
    </TableRow>
  );
};

export const ApprovalTable = ({
  sourceData,
  user,
  updateAlert,
  login,
  getApprovalData,
  usecase_name,
}) => {
  // Table State's
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginatedRows, setPaginatedRows] = useState([]);
  const [isTableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const TableData = sourceData?.approvalData || [];
  const TableHeader = [
    ...sourceData?.approvalTable_Header,
    { label: "Actions", name: "actions" },
  ];

  // Modal State
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [actionType, setActionType] = useState("");
  const [currentDataset, setCurrentDataset] = useState("");
  const [currentFileId, setCurrentFileId] = useState("");
  const [currentCountry, setCurrentCountry] = useState("");
  const [currentSource, setCurrentSource] = useState("");
  const [approvalTableHeaders, setApprovalTableHeaders] = useState([]);
  const [metadata, setMetadata] = useState();
  const [rowData, setRowData] = useState();

  function buildDynamicParams(metadata, rowData, extras = {}) {
    const params = {};
    metadata.forEach(({ label, name }) => {
      params[label] = rowData[name] ?? "";
    });
    return { ...params, ...extras };
  }

  const approveSourceFileId = async (dataset, SFF_FILE_ID, country, source) => {
    setIsLoading(true);
    let params = {};
    if (usecase_name === "gold_template_mapping") {
      params = new URLSearchParams({
        usecase_name: usecase_name || "",
        user_name: user.mail || "",
        file_id: SFF_FILE_ID || "",
        dataset_name: dataset || "",
        status: "approved",
        country_name: country,
        updated_by: user.mail || "",
        target_gold_layer: source || "",
      });
    } else {
      params = new URLSearchParams({
        usecase_name: usecase_name || "",
        user_name: user.mail || "",
        file_id: SFF_FILE_ID || "",
        dataset_name: dataset || "",
        status: "approved",
        country_name: country,
        updated_by: user.mail || "",
        source: source || "",
      });
    }

    try {
      const response = await fetch(
        api + `/approval/updateapprovaldata?${params}`,
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`API returned status ${response.status}`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Invalid API response format");
      }
      getApprovalData();
      updateAlert({
        open: true,
        message: `Approved Successfully`,
        severity: "success",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "error",
        closeFlag: true,
      });
    } finally {
      setIsLoading(false);
      setActionType("");
      setOpenDialog(false);
    }

    setIsLoading(false);
    setActionType("");
    setOpenDialog(false);
  };

  const rejectSourceFileId = async (dataset, SFF_FILE_ID, country, source) => {
    setIsLoading(true);
    try {
      let params = {};
      if (usecase_name === "gold_template_mapping") {
        params = new URLSearchParams({
          usecase_name: usecase_name || "",
          user_name: user.mail || "",
          file_id: SFF_FILE_ID || "",
          dataset_name: dataset || "",
          status: "rejected",
          country_name: country,
          updated_by: user.mail || "",
          target_gold_layer: source || "",
        });
      } else {
        params = new URLSearchParams({
          usecase_name: usecase_name || "",
          user_name: user.mail || "",
          file_id: SFF_FILE_ID || "",
          dataset_name: dataset || "",
          status: "rejected",
          country_name: country,
          updated_by: user.mail || "",
          source: source || "",
        });
      }

      const response = await fetch(
        api + `/approval/updateapprovaldata?${params}`,
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`Unexpected error occured. Please try again later`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Invalid API response format");
      }
      getApprovalData();
      updateAlert({
        open: true,
        message: `Rejected Successfully`,
        severity: "success",
        closeFlag: true,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "error",
        closeFlag: true,
      });
    } finally {
      setIsLoading(false);
      setActionType("");
      setOpenDialog(false);
    }
  };

  const getApprovalTableData = async (
    dataset,
    file_id,
    country,
    target_gold_layer,
  ) => {
    try {
      let params = {};
      if (usecase_name === "gold_template_mapping") {
        params = new URLSearchParams({
          usecase_name: usecase_name || "",
          user_name: user.mail || "",
          file_id: file_id || "",
          dataset: dataset || "",
          country: country || "",
          target_gold_layer: target_gold_layer || "",
        });
      } else {
        params = new URLSearchParams({
          usecase_name: usecase_name || "",
          user_name: user.mail || "",
          file_id: file_id || "",
          dataset: dataset || "",
          country: country,
        });
      }

      const response = await fetch(
        api + `/approval/getapprovaltabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );
      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`Unexpected error occured. Please try again later`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Invalid API response format");
      }

      setTableData(data.data || []);
      setApprovalTableHeaders(data?.metadata?.table_header_column_list || []);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setTableLoading(false);
    }
  };

  const handleModalOpen = (dataset, file_id, country, target_gold_layer) => {
    setOpenModal(!openModal);
    setTableLoading(true);
    getApprovalTableData(dataset, file_id, country, target_gold_layer);
  };

  const handleDynamicModal = (
    dataset,
    file_id,
    country,
    actionType,
    metadata,
    rowdata,
    source,
  ) => {
    setMetadata(metadata);
    setRowData(rowdata);
    setActionType(actionType);
    setCurrentDataset(dataset);
    setCurrentFileId(file_id);
    setCurrentCountry(country);
    setOpenDialog(!openDialog);
    setCurrentSource(source);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenDialog(false);
  };

  const handlePaginatedRows = (newPage) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = TableData.slice(start, end);
    return currentPageRows;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage);
    setPaginatedRows(Paginated_Rows);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = TableData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  useEffect(() => {
    setPaginatedRows(TableData.slice(0, rowsPerPage));
  }, [TableData]);

  return (
    <>
      <TableContainer className={Tablestyles.budget_tb3}>
        <Table stickyHeader className={""}>
          <TableHead className="table-heading">
            <TableRow className={""}>
              {TableHeader.map(({ label, name }, i) => (
                <StyledTableCell key={i}>{label}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row, index) => (
              <Row
                keys={index}
                rowData={row}
                headingRow={TableHeader}
                isLoading={isLoading}
                handleModalOpen={handleModalOpen}
                handleDynamicModal={handleDynamicModal}
                usecase_name={usecase_name}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {!TableData.length && (
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          No awaiting data found!
        </div>
      )}

      {/* Pagination */}
      {TableData.length > 0 && (
        <div>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={TableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}

      {/* Modal to show single File_Id's Table Data */}
      <ApprovalModal
        sourceData={sourceData}
        openModal={openModal}
        closeModel={handleCloseModal}
        isTableLoading={isTableLoading}
        tableData={tableData}
        approvalTableHeaders={approvalTableHeaders}
      />

      {/* Genral Dialog */}
      <DynamicDialog
        openModal={openDialog}
        closeModel={handleCloseModal}
        hasCustomCancelButton={false}
        title={"Confirmation"}
        content={
          <p
            style={{ fontSize: "16px", color: "black", marginTop: "6px" }}
          >{`Records of this file_Id will be ${
            actionType && actionType === "Approve" ? "Approved" : "rejected"
          }. Are you sure?`}</p>
        }
        actions={
          <>
            {actionType && actionType === "Approve" && (
              <Button
                onClick={() =>
                  approveSourceFileId(
                    currentDataset,
                    currentFileId,
                    currentCountry,
                    currentSource,
                  )
                }
                style={{
                  backgroundColor: "#46596A",
                  fontFamily: "Hind Siliguri",
                  fontSize: "12px",
                  fontWeight: "bold",
                  marginRight: "5px",
                  color: "white",
                }}
              >
                Continue {isLoading && <Loader />}
              </Button>
            )}
            {actionType && actionType === "Reject" && (
              <Button
                onClick={() =>
                  rejectSourceFileId(
                    currentDataset,
                    currentFileId,
                    currentCountry,
                    currentSource,
                  )
                }
                style={{
                  backgroundColor: "#46596A",
                  fontFamily: "Hind Siliguri",
                  fontSize: "12px",
                  fontWeight: "bold",
                  marginRight: "5px",
                  color: "white",
                }}
              >
                Continue {isLoading && <Loader />}
              </Button>
            )}
          </>
        }
      />
    </>
  );
};
